export default {
	settings_layout_group_search: 'Suche',
	settings_layout_spotlight_search_caption:
		'Moderne Suchleiste mit Tastenkürzel (⌘K), Schnellaktionen und Kommandopalette. Bei Deaktivierung wird die klassische Inline-Suche verwendet.',
	settings_layout_spotlight_search_label: 'Spotlight-Suche',
	spotlight_action_dark_mode: 'Dark Mode aktivieren',
	spotlight_action_layout_settings: 'Layout-Einstellungen',
	spotlight_action_light_mode: 'Light Mode aktivieren',
	spotlight_action_notification_settings: 'Benachrichtigungen',
	spotlight_action_theme_settings: 'Theme-Einstellungen',
	spotlight_actions: 'Schnellaktionen',
	spotlight_active_favorites_clear_all: 'Alle entfernen',
	spotlight_active_favorites_label: 'Aktive Favoriten',
	spotlight_active_favorites_more_aria: 'Weitere aktive Favoriten anzeigen',
	spotlight_back: 'zurück',
	spotlight_clear_all_tooltip: 'Eingabe zurücksetzen',
	spotlight_close: 'schließen',
	spotlight_favorites: 'Favoriten',
	spotlight_favorites_remove_chip: 'Favorit entfernen',
	spotlight_module_all: 'Alle Module',
	spotlight_module_selector_aria: 'Suchbereich auswählen',
	spotlight_navigate: 'Navigation',
	spotlight_navigate_hint: 'navigieren',
	spotlight_press_enter_to_search: 'Drücke ↵ um ein Modul zum Suchen auszuwählen',
	spotlight_recent: 'Letzte Suchen',
	spotlight_recent_in_module_tooltip: 'Zuletzt in {module} gesucht — klicken um Bereich zu wechseln',
	spotlight_recent_other_modules: '+{count} weitere Module',
	spotlight_remove: 'Entfernen',
	spotlight_search_for_query: 'Nach „{searchQuery}" suchen',
	spotlight_search_in: 'Suchen in...',
	spotlight_search_in_module: '„{searchQuery}" in {module} suchen',
	spotlight_search_placeholder: 'Suche...',
	spotlight_select: 'auswählen',
	spotlight_tab_toggle_scope: 'Bereich wechseln',
	spotlight_where_to_search: 'Wo möchtest du „{searchQuery}" suchen?',
};
